import { API_ENDPOINTS } from "config/config";

export const getStripeProductsConfig = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GET_STRIPE_PRODUCTS_CONFIG, {
    params,
    showLoader: false,
  });
  return response.data?.data ?? response.data;
};

export const syncStripeProducts = async (api) => {
  const response = await api.post(
    API_ENDPOINTS.SYNC_STRIPE_PRODUCTS,
    {},
    { showLoader: false }
  );
  return response.data?.data ?? response.data;
};

export const updateStripeProductTracking = async (api, items) => {
  const response = await api.put(
    API_ENDPOINTS.UPDATE_STRIPE_PRODUCT_TRACKING,
    { items },
    { showLoader: false }
  );
  return response.data?.data ?? response.data;
};
